import classNames from "classnames";
import {Navigation, Slide} from "../model/types";
import {useMainCarousel} from "../model/hooks/useMainCarousel";
import {MainCarouselSlide} from "../ui/MainCarouselSlide";
import {Link} from "@/shared/ui/Link";
import {Svg} from "@/shared/ui/Svg";
import styles from "./MainCarousel.module.scss";

type Props = {
    slides: Slide[];
    isMobile: boolean;
    navigations: Navigation[];
}

export const MainCarousel = ({slides, isMobile, navigations}: Props) => {
    const {
        dots,
        carouselRef,
        scrollPrev,
        scrollNext,
        selectedIndex,
        onDotClick,
    } = useMainCarousel(slides.length);

    if (slides.length === 0) {
        return null;
    }

    return (
        <div className={styles.carousel}>
            <div ref={carouselRef} className={styles.viewport}>
                <div className={styles.container}>
                    {slides.map((slide) => (
                        <MainCarouselSlide key={slide.id} className={styles.slide} slide={slide} isMobile={isMobile} />
                    ))}
                </div>
            </div>
            {slides.length > 1 && (
                <>
                    <button type={`button`} className={classNames(styles.button, styles.prev)} onClick={scrollPrev}>
                        <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                    </button>
                    <button type={`button`} className={classNames(styles.button, styles.next)} onClick={scrollNext}>
                        <Svg id={`arrowRight`} className={styles.arrowIcon} />
                    </button>
                    <div className={styles.dots}>
                        {dots.map((_, index) => (
                            <button
                                key={`dot-${index}`}
                                onClick={() => onDotClick(index)}
                                className={classNames(styles.dot, {[styles.selected]: index === selectedIndex})}
                            />
                        ))}
                    </div>
                </>
            )}
            {navigations.length > 0 && (
                <div className={styles.navigationContainer}>
                    <div className={styles.navigations}>
                        {navigations.map((navigation) => (
                            <Link key={navigation.link} href={navigation.link} className={styles.navigation}>
                                <div className={styles.iconContainer}>
                                    <Svg id={navigation.svgName} className={styles.icon} />
                                </div>
                                <p className={styles.linkName}>{navigation.linkName}</p>
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
